'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeFacebookForm = exports.facebookFormAction = exports.FACEBOOK_FORM = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.buildAccountDetails = buildAccountDetails;
exports.buildProduct = buildProduct;
exports.createAccount = createAccount;
exports.doInitializeFacebookForm = doInitializeFacebookForm;
exports.doSubmitFacebookForm = doSubmitFacebookForm;
exports.watchFacebookFormSagas = watchFacebookFormSagas;

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _reduxFormSaga = require('redux-form-saga');

var _effects = require('redux-saga/effects');

var _helpers = require('redux/saga/helpers');

var _friendbuy = require('redux/saga/selectors/friendbuy');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _utmValues = require('helpers/utmValues');

var _Consent = require('components/Consent/Consent.saga');

var _Authentication = require('features/Login/Authentication.saga');

var _Signup = require('features/Signup/Signup.saga');

var _apiErrorCodes = require('constants/api-error-codes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(buildAccountDetails),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(createAccount),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doInitializeFacebookForm),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doSubmitFacebookForm),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchFacebookFormSagas);

var messages = (0, _reactIntl.defineMessages)({
  contactSupport: {
    id: 'facebook-signup.contact-support',
    defaultMessage: 'Sorry, we’re unable to create your account at this time. Please, <a target="_blank" rel="noopener noreferrer" href="/contact">reach out to us</a> for account help.',
    hasHtml: true
  },
  disclaimer: {
    id: 'facebook-signup.disclaimer',
    defaultMessage: 'By clicking ‘Sign up with Facebook’ or ‘Continue,’ I agree to the {linkTerms} and {linkPrivacy}.'
  },
  missingEmail: {
    id: 'facebook-signup.missing-email',
    defaultMessage: 'Your Facebook account must have an email to sign up. Please add one or sign up via email.'
  }
});

var FACEBOOK_FORM = exports.FACEBOOK_FORM = 'signup-card-facebook';
var facebookFormAction = exports.facebookFormAction = (0, _reduxFormSaga.createFormAction)(FACEBOOK_FORM);

var initializeFacebookForm = exports.initializeFacebookForm = function initializeFacebookForm(hiddenFields) {
  return {
    type: 'INITIALIZE_' + FACEBOOK_FORM,
    hiddenFields: hiddenFields
  };
};

function buildAccountDetails(client, form) {
  var _ref, _ref2, activeLocation, consents, conversion, friendbuyCode;

  return _regenerator2.default.wrap(function buildAccountDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_helpers.getUserLocation, client), (0, _effects.call)(_Consent.transformConsentForApi, form), (0, _effects.call)(_utmValues.getForApi), (0, _effects.select)(_friendbuy.friendbuyCode)]);

        case 2:
          _ref = _context.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 4);
          activeLocation = _ref2[0];
          consents = _ref2[1];
          conversion = _ref2[2];
          friendbuyCode = _ref2[3];


          // Ensure RAF leads are correctly tracked
          if (friendbuyCode) {
            (0, _deep.deepAssign)('utm.utm_term', conversion, friendbuyCode);
          }

          return _context.abrupt('return', {
            consents: consents,
            conversion: conversion,
            newsletter_subscribed: true,
            gls_location_id: (0, _deep.deepExtract)('location.id', activeLocation, null)
          });

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function buildProduct(form) {
  var productKey = {
    offer: 'msa_offer_id',
    plan: 'plan_id'
  }[form.productType];

  return productKey ? (0, _defineProperty3.default)({}, productKey, form.productId) : {};
}

function createAccount(client, facebookToken, accountDetails, product) {
  var errorCode, message;
  return _regenerator2.default.wrap(function createAccount$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_Authentication.createUserAndLogIn, client, facebookFormAction, (0, _extends3.default)({}, accountDetails, product, {
            facebook: { token: facebookToken }
          }));

        case 3:
          return _context2.abrupt('return', _context2.sent);

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2['catch'](0);
          errorCode = (0, _deep.deepExtract)('code', _context2.t0);
          message = void 0;

          if (!(errorCode === _apiErrorCodes.ERROR_SIGNUP_FB_EXISTING_ACCOUNT)) {
            _context2.next = 18;
            break;
          }

          _context2.next = 13;
          return (0, _effects.call)(_Authentication.doLoginWithFacebook, client, null, facebookToken);

        case 13:
          _context2.next = 15;
          return (0, _effects.call)(_helpers.gtmSafeRedirect, '/');

        case 15:
          return _context2.abrupt('return');

        case 18:
          if (!(errorCode === _apiErrorCodes.ERROR_SIGNUP_FB_MISSING_EMAIL)) {
            _context2.next = 22;
            break;
          }

          message = messages.missingEmail.defaultMessage;
          _context2.next = 25;
          break;

        case 22:
          _context2.next = 24;
          return (0, _effects.spawn)(logger.error, 'Failed to create account with facebook token', _context2.t0);

        case 24:
          message = messages.contactSupport.defaultMessage;

        case 25:
          return _context2.abrupt('return', _promise2.default.reject(message));

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 6]]);
}

function doInitializeFacebookForm(client, _ref4) {
  var hiddenFields = _ref4.hiddenFields;
  return _regenerator2.default.wrap(function doInitializeFacebookForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _reduxForm.initialize)(FACEBOOK_FORM, (0, _extends3.default)({}, hiddenFields, {
            marketing: true,
            marketingDisclaimer: null,
            searchable: true,
            searchableDisclaimer: null,
            terms: messages.disclaimer.defaultMessage
          })));

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doSubmitFacebookForm(client, _ref5) {
  var form = _ref5.payload;
  var FB, facebookToken, accountDetails, product, userId, profile, message;
  return _regenerator2.default.wrap(function doSubmitFacebookForm$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          FB = client && client.FB || window.FB;
          _context4.next = 4;
          return (0, _effects.call)(_Authentication.authorizeFacebook, client);

        case 4:
          facebookToken = _context4.sent;
          _context4.next = 7;
          return (0, _effects.call)(buildAccountDetails, client, form);

        case 7:
          accountDetails = _context4.sent;
          _context4.next = 10;
          return (0, _effects.call)(buildProduct, form);

        case 10:
          product = _context4.sent;
          _context4.next = 13;
          return (0, _effects.call)(createAccount, client, facebookToken, accountDetails, product);

        case 13:
          userId = _context4.sent;
          _context4.next = 16;
          return (0, _effects.call)(_Authentication.getFacebookProfile, FB);

        case 16:
          profile = _context4.sent;
          _context4.next = 19;
          return (0, _effects.call)(_Signup.postSignupTracking, 'facebook', profile, userId);

        case 19:
          _context4.next = 21;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Account Creation');

        case 21:
          _context4.next = 23;
          return (0, _effects.put)(facebookFormAction.success());

        case 23:
          _context4.next = 32;
          break;

        case 25:
          _context4.prev = 25;
          _context4.t0 = _context4['catch'](0);
          message = (0, _deep.deepExtract)('message', _context4.t0);
          _context4.next = 30;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Account Creation Error', message || 'Unknown Error');

        case 30:
          _context4.next = 32;
          return (0, _effects.put)(facebookFormAction.failure(new _reduxForm.SubmissionError({
            _error: message || messages.contactSupport.defaultMessage
          })));

        case 32:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 25]]);
}

function watchFacebookFormSagas(client) {
  return _regenerator2.default.wrap(function watchFacebookFormSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, initializeFacebookForm().type, doInitializeFacebookForm, client);

        case 2:
          _context5.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, facebookFormAction.REQUEST, doSubmitFacebookForm, client);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}